
import Vue from 'vue'
import { functions } from '@/firebase/functions'
import { showSnackbar } from '@/globalActions'

export default Vue.extend({
  name: 'TeamPage',
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      spiideoDialog: false,
      spiideoSyncing: false,
      spiideoSaving: false,
      spiideoIdUnlocked: false,
      editSpiideoTeamId: '',
      spiideo_teamId: null as string | null,
      teamName: ''
    }
  },
  computed: {
    teamId (): string {
      return (this.$route.params.team as string) || ''
    },
    teamData (): Record<string, any> {
      const fromStore =
        this.$store.state.ClubTeamsModule &&
        this.$store.state.ClubTeamsModule.data &&
        this.$store.state.ClubTeamsModule.data[this.teamId]
      if (fromStore) {
        return fromStore
      }
      return (this.$route.params.data as Record<string, any>) || {}
    },
    players (): Array<{ number?: string; name?: string }> {
      return (this.teamData && this.teamData.players) || []
    },
    currentSpiideoTeamId (): string | null {
      return this.spiideo_teamId || this.teamData.spiideo_teamId || null
    },
    isSpiideoSynced (): boolean {
      return !!this.currentSpiideoTeamId
    }
  },
  watch: {
    teamId: {
      immediate: true,
      handler (id: string) {
        if (id) {
          this.loadTeam(id)
        }
      }
    }
  },
  methods: {
    async loadTeam (teamId: string) {
      try {
        await this.$store.dispatch('ClubTeamsModule/fetchById', teamId)
        const team = this.$store.state.ClubTeamsModule.data[teamId] || {}
        this.teamName = team.name || (this.$route.params.data as any)?.name || ''
        this.spiideo_teamId = team.spiideo_teamId || null
      } catch (err) {
        console.error('loadTeam', err)
        this.teamName = (this.$route.params.data as any)?.name || ''
      }
    },
    openSpiideoDialog () {
      this.editSpiideoTeamId = this.currentSpiideoTeamId || ''
      this.spiideoIdUnlocked = false
      this.spiideoDialog = true
    },
    closeSpiideoDialog () {
      this.spiideoDialog = false
      this.spiideoIdUnlocked = false
      this.editSpiideoTeamId = this.currentSpiideoTeamId || ''
    },
    toggleSpiideoIdLock () {
      this.spiideoIdUnlocked = !this.spiideoIdUnlocked
      if (!this.spiideoIdUnlocked) {
        this.editSpiideoTeamId = this.currentSpiideoTeamId || ''
      }
    },
    async syncToSpiideo () {
      if (!this.teamId || this.isSpiideoSynced) {
        return
      }
      const clubId = this.teamData.clubId || this.id || this.$route.params.id
      if (clubId) {
        await this.$store.dispatch('ClubsModule/fetchById', clubId)
        const club = this.$store.state.ClubsModule.data[clubId]
        if (!club || !club.spiideo_assets_id) {
          showSnackbar(this.$t('spiideo-club-logo-required') as string, { duration: 6000 })
          return
        }
      }
      this.spiideoSyncing = true
      try {
        const syncTeam = functions.httpsCallable('spiideoSyncTeamV2')
        const result: any = await syncTeam({ teamId: this.teamId })
        this.spiideo_teamId =
          (result && result.data && result.data.spiideo_teamId) || null
        this.editSpiideoTeamId = this.spiideo_teamId || ''
        this.spiideoIdUnlocked = false
        showSnackbar(this.$t('spiideo-team-synced') as string)
        await this.loadTeam(this.teamId)
      } catch (err: any) {
        console.error('spiideoSyncTeamV2', err)
        const message =
          (err && err.message) ||
          (this.$t('spiideo-sync-failed') as string)
        showSnackbar(message, { duration: 5000 })
      } finally {
        this.spiideoSyncing = false
      }
    },
    async saveSpiideoTeamId () {
      if (!this.teamId || !this.spiideoIdUnlocked) {
        return
      }
      const nextId = (this.editSpiideoTeamId || '').trim()
      if (!nextId) {
        showSnackbar(this.$t('spiideo-team-id-required') as string, { duration: 5000 })
        return
      }
      this.spiideoSaving = true
      try {
        await this.$store.dispatch('ClubTeamsModule/patch', {
          id: this.teamId,
          spiideo_teamId: nextId
        })
        this.spiideo_teamId = nextId
        this.spiideoIdUnlocked = false
        showSnackbar(this.$t('spiideo-team-id-updated') as string, { color: 'success' })
      } catch (err: any) {
        console.error('saveSpiideoTeamId', err)
        showSnackbar(
          (err && err.message) || (this.$t('spiideo-sync-failed') as string),
          { duration: 5000 }
        )
      } finally {
        this.spiideoSaving = false
      }
    }
  }
})
